/*******************************************************************************
REMOVE ERROR NOTIFICATION
Removes any error notifications from the screen.
*******************************************************************************/

export default function removeErrorNotification() {

    const $notification = $('.error-notification-bar');

    // Handle notifications in the daily section differently than the typical notification
    if ($notification.hasClass('daily-error') || $notification.hasClass('daily-success')) {

      // Hide notification bar
      $('.notification-bar.full-width').addClass('hide');

      // Hide and reset error and success message
      $notification.find('.daily-error').addClass('hide').text();
      $notification.find('.daily-success').addClass('hide').text();
    }


    // All other notification bars
    else {

      // Remove notification bar element
      $notification.remove();
    }
}
